module.exports = __webpack_public_path__ + "static/media/coronaBar.40923391.png";